import React, {useState} from "react";
import MenuItem from "@material-ui/core/MenuItem";
import Select from "@material-ui/core/Select";
import TextField from "@material-ui/core/TextField";
import Autocomplete from "@material-ui/lab/Autocomplete";
import ReactDatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import {Controller, useForm} from "react-hook-form";
//import slices
import {useDispatch, useSelector} from "react-redux";
import ClipLoader from "react-spinners/ClipLoader";
import {competences as competencesDataset} from "../../../db/datasets/competences";
import {closeDialog} from "../../../slices/dialog";
import {selectUid} from "../../../slices/auth";
import {updateStudentBgItem} from "../../../api/common";
import "../../CommonComponents.scss";
import {useTranslation} from "react-i18next";
import { analyticsEvents, competenceLevels } from "../../../db/models/const";

export const EditCvCompetence = ({competence}) => {
    const [loading, setLoading] = useState(false);
    const {register, handleSubmit, control, errors} = useForm({
        defaultValues: {
            competence: competencesDataset[competence?.labelId || 0],
            levelId: competence?.levelId || 0,
            certificate: competence?.certificate || "",
            date: competence?.date ? new Date(competence.date.seconds * 1000) : null
        },
    });
    const uid = useSelector(selectUid);
    const dispatch = useDispatch();
    const {t} = useTranslation();

    const onSave = (data) => {
        let c = {
            ...competence,
            labelId: data.competence.id,
            levelId: data.levelId,
            certificate: data.certificate || "",
            date: data.date
        };
        setLoading(true);
        updateStudentBgItem(uid, "COMP", c, competence == null)
            .then(() => {
                setLoading(false);
                dispatch(closeDialog());
            })
            .catch((error) => setLoading(false));
    };

    return (
        <div className="editBgCompetence bg-dialog">
            <form onSubmit={handleSubmit(onSave)}>
                <div className="element">
                    <div className="label">{t("student_comp_label")}</div>
                    <Controller
                        render={({onChange, ...props}) => (
                            <Autocomplete
                                {...props}
                                options={competencesDataset}
                                getOptionLabel={(option) => option.label}
                                renderInput={(params) => <TextField {...params} />}
                                onChange={(e, x) => {
                                    onChange(x);
                                }}
                            />
                        )}
                        name={"competence"}
                        rules={{required: true}}
                        control={control}
                    />
                    {errors.labelId && <p>{t("student_comp_error")}</p>}
                </div>
                <div className="element">
                    <div className="label">{t("student_comp_level_label")}</div>
                    <Controller
                        render={({onChange, ...props}) => (
                            <Select
                                fullWidth
                                {...props}
                                onChange={(e) => onChange(e.target.value)}
                            >
                                {competenceLevels.map((x) => (
                                    <MenuItem key={x.id} value={x.id}>
                                        {t(x.label)}
                                    </MenuItem>
                                ))}
                            </Select>
                        )}
                        name={"levelId"}
                        rules={{required: true}}
                        control={control}
                    />
                    {errors.levelId && <p>{t("student_comp_level_error")}</p>}
                </div>
                <div className="element">
                    <div className="label">{t("student_comp_cert_label")}</div>
                    <input
                        type="text"
                        ref={register}
                        name="certificate"
                        placeholder={t("student_comp_cert_ph")}
                    ></input>
                </div>

                <div className="element">
                    <div className="label">{t("student_comp_date_label")}</div>
                    <Controller
                        control={control}
                        name="date"
                        render={({onChange, onBlur, value}) => (
                            <ReactDatePicker
                                onChange={onChange}
                                onBlur={onBlur}
                                selected={value}
                                dateFormat="MM/yyyy"
                                showMonthYearPicker
                                popperPlacement="top-start"
                            />
                        )}
                    />
                </div>
                {!loading && <input type="submit" value={t("student_comp_submit")}></input>}
                {loading && (
                    <div className="loader">
                        <ClipLoader size={20} color={"#7400b8"} loading={true}/>
                    </div>
                )}
            </form>
        </div>
    );
};
